import PropTypes from 'prop-types'
import React from 'react'
import Link from 'next/link'

export class Promote extends React.PureComponent {
  render () {
    const {isAvailable, adSeo} = this.props
    return (
      <div className={`moji-oglasi-akcije-item ${isAvailable ? `` : `disabled`}`}>
        {
          isAvailable
            ? <Link href={`/activatePromo?ad=${adSeo}`} as={`/profil/oglasi/promo/${adSeo}`}>
              <a><i className='ico-promovisi-oglas ico' /> Promoviši</a>
            </Link>
            : <a href='javascript:void(0)'><i className='ico-promovisi-oglas ico' /> Promoviši</a>
        }
      </div>
    )
  }
}

Promote.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
  adSeo: PropTypes.string.isRequired
}

Promote.defaultProps = {
  isAvailable: true
}
